import { render, staticRenderFns } from "./CardDataItem.vue?vue&type=template&id=7fb5eb4e&scoped=true"
import script from "./CardDataItem.vue?vue&type=script&lang=ts"
export * from "./CardDataItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb5eb4e",
  null
  
)

export default component.exports